<template>
    <div class="project-details-page">
        <div class="feature-area-wrapper"><i class="fa fa-chevron-left menu-icon"></i>
            <div class="feature-area feature-area-compact">
                <div class="pageHeader row">
                    <div class="col">
                        <div class="search-results-section mb-2">
                            <div class="title-container" :class="{'matchmaker': $route.name === 'search-project-details-matchmaker'}">
                                <a :href="'/search/' + $route.params.search_id + '/projects'" class="page-title results-title" @click="goTo('search-results')" v-if="$route.params.search_id && $route.name !== 'search-project-details-matchmaker'" rel="noopener">Search Results</a>
                                <a :href="'/search/' + $route.params.search_id + '/projects'" class="page-title results-title" @click="goTo('search-results')" v-if="$route.params.search_id && $route.name === 'search-project-details-matchmaker'" rel="noopener">Matchmaker Results</a><i class="fas fa-chevron-right title-divider" v-if="$route.params.search_id"></i><div class="page-title mt-1">Project Details</div>
                                <!-- <div v-if="$store.state.searchMeta" class="sub-title">
                                    {{$store.state.searchMeta.total |  addCommas}} Results
                                </div> -->
                            </div>
                        </div>
                    </div>
                    <div class="col-auto">
                        <div class="search-criteria-page ">
                            <div class="action-buttons text-end">
                                <b-dropdown variant="light" class="ms-2" right>
                                    <template v-slot:button-content>
                                        <i class="fas fa-link"></i>
                                        <span class="btn-text ms-2 font-weight-bold">Share</span>
                                    </template>
                                        <b-dropdown-item id="emailLink" v-bind:href="shareEmailURL" @click="shareProject('email')" rel="noopener">Email</b-dropdown-item>
                                        <b-dropdown-item href @click.prevent="shareProject('copy')" rel="noopener">Copy Link</b-dropdown-item>
                                </b-dropdown>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div>
            <div class="sidebar">
                <div v-if="this.$route.params.search_id">
                    <button type="button" class="back-btn" @click="goTo('search-results')" v-if="this.$route.name === 'search-project-details' || this.$route.name === 'search-project-details-matchmaker'">
						<i class="fa fa-chevron-left menu-icon"></i>Back to Search Results
                    </button>
                    <button type="button" class="back-btn" @click="goTo('charts')" v-if="this.$route.name === 'search-project-details-charts'">
                        <i class="fa fa-chevron-left menu-icon"></i>Back to Charts
                    </button>
                    <button type="button" class="back-btn" @click="goTo('map')" v-if="this.$route.name === 'search-project-details-map'">
                        <i class="fa fa-chevron-left menu-icon"></i>Back to Map
                    </button>
                    <button type="button" class="back-btn" @click="goTo('publications-tab')" v-if="this.$route.name === 'publications-project-details' || this.$route.name === 'search-project-details-publications'">
                        <i class="fa fa-chevron-left menu-icon"></i>Back to Publications
                    </button>
                    <button type="button" class="back-btn" @click="goTo('news-tab')" v-if="this.$route.name === 'search-project-details-news'">
                        <i class="fa fa-chevron-left menu-icon"></i>Back to News &amp; More
                    </button>
                </div>

                <h2 class="menu-header fh-small"><b-link class="collapsed" v-b-toggle.menu-items rel="noopener"><i class="fas fa-filter nav-icon-filter"></i>Section Menu<span class="on"></span><span class="off"></span></b-link></h2>
                <b-collapse id="menu-items" class="collapse" :visible="breakpoints.gt.md">
                    <ul>
                        <li>
                            <a class="text-decoration-none" :class="{'active': selectedSection === 'description', 'disabled': projectNotAvailable}" href="#description" @click="userScrollStarted = false;goTo('description')" rel="noopener"><i class="fa fa-clipboard-list menu-icon"></i>Description
                                <i class="fa fa-chevron-right menu-icon right-icon"></i>
                            </a>
                        </li>
                        <li>
                            <a class="text-decoration-none" :class="{'active': selectedSection === 'details', 'disabled': projectNotAvailable}" href="#details" @click="userScrollStarted = false;goTo('details')" rel="noopener"><i class="fa fa-file-alt menu-icon"></i>Details
                               <i class="fa fa-chevron-right menu-icon right-icon"></i>
                            </a>
                        </li>
                        <li>
                            <a class="text-decoration-none" :class="{'active': selectedSection === 'sub-Projects', 'disabled': projectNotAvailable}" href="#sub-Projects" @click="userScrollStarted = false;goTo('sub-Projects')" rel="noopener"><i class="fa fa-sitemap menu-icon"></i>Sub-Projects
								<i class="fa fa-chevron-right menu-icon right-icon"></i>
                            </a>
                        </li>
                        <li>
                            <a class="text-decoration-none" :class="{'active': selectedSection === 'publications', 'disabled': projectNotAvailable}" href="#publications" @click="userScrollStarted = false;goTo('publications')" rel="noopener"><i class="fa fa-book-open menu-icon"></i>Publications
                                <i class="fa fa-chevron-right menu-icon right-icon"></i>
                            </a>
                        </li>
                        <li>
                            <a class="text-decoration-none" :class="{'active': selectedSection === 'patents', 'disabled': projectNotAvailable}" href="#patents" @click="userScrollStarted = false;goTo('patents')" rel="noopener"><i class="far fa-lightbulb menu-icon"></i>Patents
                                <i class="fa fa-chevron-right menu-icon right-icon"></i>
                            </a>
                        </li>
                        <li>
                            <a class="text-decoration-none" :class="{'active': selectedSection === 'outcomes', 'disabled': projectNotAvailable}" href="#outcomes" @click="userScrollStarted = false;goTo('outcomes')" rel="noopener"><i class="far fa-folder menu-icon"></i>Outcomes
                                <i class="fa fa-chevron-right menu-icon right-icon"></i>
                            </a>
                        </li>
                        <li>
                            <a class="text-decoration-none" :class="{'active': selectedSection === 'clinical-studies', 'disabled': projectNotAvailable}" href="#clinical-studies" @click="userScrollStarted = false;goTo('clinical-studies')" rel="noopener"><i class="fas fa-microscope menu-icon"></i>Clinical Studies
                                <i class="fa fa-chevron-right menu-icon right-icon"></i>
                            </a>
                        </li>
                        <li>
                            <a class="text-decoration-none" :class="{'active': selectedSection === 'news', 'disabled': projectNotAvailable}" href="#news" @click.prevent="userScrollStarted = false;goTo('news')" rel="noopener"><i class="far fa-newspaper menu-icon"></i>News and More
                                <i class="fa fa-chevron-right menu-icon right-icon"></i>
                            </a>
                        </li>
                        <li>
                            <a class="text-decoration-none" :class="{'active': selectedSection === 'history', 'disabled': projectNotAvailable}" href="#history" @click="userScrollStarted = false;goTo('history')" rel="noopener"><i class="fas fa-history menu-icon"></i>History
                                <i class="fa fa-chevron-right menu-icon right-icon"></i>
                            </a>
                        </li>
                        <li>
                            <a class="text-decoration-none" :class="{'active': selectedSection === 'similar-Projects', 'disabled': projectNotAvailable}" href="#similar-Projects" @click="userScrollStarted = false;goTo('similar-Projects')" rel="noopener"><i class="fas fa-project-diagram header-icon menu-icon"></i>Similar Projects
                                <i class="fa fa-chevron-right menu-icon right-icon"></i>
                            </a>
                        </li>
                        <!-- <li><a :class="{'active': selectedSection === 'nearby-Projects'}" href="#nearby-Projects" @click="goTo('nearby-Projects')"><svgicon name="map-marker" class="menu-icon"></svgicon>Nearby Projects</a></li> -->
                        <!-- <li><a :class="{'active': selectedSection === 'links'}" href="#links" @click="goTo('links')"><svgicon name="nodes" class="menu-icon"></svgicon>Links</a></li> -->
                    </ul>
                </b-collapse>
            </div>
            <div class="content-with-sidebar">
                <div v-if="projectNotAvailable" class="no-data">{{ invalidProjectIdMsg }}</div>
                <div class="project-details" ref="projectDetails" v-if="!projectNotAvailable">
                    <div class="project-basics" id="project-basics" ref="projectBasics">
                        <div v-if="basicInfoLoading" class="loading"><span class="loader">Loading...</span></div>
                        <div class="title" v-if="projectDetails.description && projectDetails.description.project_title" v-html="getHighlightedText(projectDetails.description.project_title)"></div>
                        <div class="title" v-else-if="projectDetails.basicInfo && projectDetails.basicInfo.project_title" v-html="getHighlightedText(projectDetails.basicInfo.project_title)"></div>
                        <div class="row" v-if="projectDetails.basicInfo && projectDetails.basicInfo">
                            <div class="col mb-2"><div class="row">
                                <span class="col-12 data-label"><template v-if="projectDetails.basicInfo && projectDetails.basicInfo.subproject_id">Parent</template> Project Number</span>
                                <span class="data col-12" v-if="projectDetails.basicInfo">
                                    <template v-if="projectDetails.basicInfo.subproject_id"><a href @click.prevent="setParentProjectURL()" rel="noopener">{{projectDetails.basicInfo.project_num}} <i class="fa fa-external-link-alt widget-button-icon icon-exit-link widget-button-icon icon-exit-link" alt="Popout"/></a></template>
                                    <template v-if="!projectDetails.basicInfo.subproject_id">{{projectDetails.basicInfo.project_num}}</template>
                                    &nbsp;
                                    <span class="ms-1 data nidb_link text-nowrap"
                                        v-if="projectDetails.basicInfo && projectDetails.basicInfo.nidb_report"><a
                                            v-if="externalURLs.reporter_nidb_report_url" title="NIDB Annual Report"
                                            :href="externalURLs.reporter_nidb_report_url.replace('{0}', projectDetails.basicInfo.nidb_report)"
                                            target="_blank">NIDB ANNUAL REPORT</a></span>
                                </span>
                                </div>
                            </div>
                            <div class="col mb-2" v-if="projectDetails.basicInfo && projectDetails.basicInfo.frmr_project_num">
                                <div class="row">
                                <span class="col-12 data-label">Former  Number</span>
                                <span class="data col-12" v-if="projectDetails.basicInfo">{{projectDetails.basicInfo.frmr_project_num}}</span>
                                </div>
                            </div>
                            <div class="col mb-2" v-if="projectDetails.basicInfo && projectDetails.basicInfo.subproject_id">
                                <div class="row">
                                <span class="col-12 data-label">Sub-Project ID</span>
                                <span class="data col-12">{{projectDetails.basicInfo.subproject_id}}</span>
                                </div>
                            </div>
                            <div class="col mb-2">
                                <div class="row">
                                <span class="col-12 data-label">Contact PI/Project Leader</span>
                                <span class="data col-12" v-if="projectDetails.basicInfo">
                                  <span>{{projectDetails.basicInfo.contact_pi_name}}</span><br>
                                  <a  class="text-decoration-none" href="#details" @click="goTo('details')" v-if="projectDetails.basicInfo && projectDetails.basicInfo.others_pis && projectDetails.basicInfo.others_pis.length > 0" rel="noopener">Other PIs</a>
                                </span>
                                </div>
                            </div>
                            <div class="col mb-2">
                                <div class="row">
                                <span class="col-12 data-label">Awardee Organization</span>
                                <span class="data col-12" v-if="projectDetails.basicInfo">{{projectDetails.basicInfo.org_name}}</span>
                            </div>
                            </div>
                        </div>
                    </div>
                    <div class="fixed-data" v-if="!projectNotAvailable && !basicInfoLoading">
                        <div class="project-description sidebar-sections" id="description">
                            <div class="section-header">
								<i class="fa fa-clipboard-list header-icon"></i>
                                <span>Description</span>
                            </div>
                            <div class="data-section">
                                <div class="data-header">Abstract Text</div>
                                <div class="project-description-data" id="abstract_text" :class="{'no-data': projectDetails.basicInfo && !projectDetails.basicInfo.abstract_text, 'loading': descriptionLoading}">
                                    <div v-if="descriptionLoading" class="loading"><span class="loader">Loading...</span></div>
                                    <div class="project-description-data" v-if="projectDetails.basicInfo && projectDetails.basicInfo.abstract_text">
                                        <div class="data hightlight-text" v-html="getHighlightedText(projectDetails.basicInfo.abstract_text)"></div>
                                    </div>
                                    <div v-else-if="!descriptionLoading">Data not available.</div>
                                </div>
                            </div>

                            <div class="data-section">
                                <div class="data-header">Public Health Relevance Statement</div>
                                <div class="project-description-data" id="relevance_statement" :class="{'no-data': projectDetails.basicInfo && !projectDetails.basicInfo.public_health_relevance, 'loading': descriptionLoading}">
                                    <div v-if="descriptionLoading" class="loading"><span class="loader">Loading...</span></div>
                                    <div class="project-description-data" v-if="projectDetails.basicInfo && projectDetails.basicInfo.public_health_relevance">
                                        <div class="data hightlight-text" v-html="getHighlightedText(projectDetails.basicInfo.public_health_relevance)"></div>
                                    </div>
                                    <div v-else-if="!descriptionLoading">Data not available.</div>
                                </div>
                            </div>

                            <div class="data-section" v-if="projectDetails.basicInfo && projectDetails.basicInfo.spending_categories">
                                <div class="data-header">NIH Spending Category</div>
                                <div class="project-description-data-wrapper" id="spending_categories"
                                    :class="{'loading': descriptionLoading,
                                             'no-read-more': !isLongText('spending_categories')}">
                                    <div v-if="descriptionLoading" class="loading"><span class="loader">Loading...</span></div>
                                    <div class="project-description-data">
                                        <div class="data">
                                            <template v-for="(category, index) in projectDetails.basicInfo.spending_categories" v-bind:key="'spending_categories' + index">
                                                <span class="term" v-html="getHighlightedText(category)"></span>
                                            </template>
                                        </div>
                                    </div>
                                    <div v-if="!descriptionLoading && projectDetails.basicInfo.spending_categories.length === 0">No NIH Spending Category available.</div>
                                    <button class="project-button" @click.prevent="expandDescription('spending_categories')" v-if="isLongText('spending_categories')">Read
                                        <span v-if="!expanded['spending_categories']">More</span><span v-else>Less</span>
                                    </button>
                                </div>
                            </div>

                            <div class="data-section">
                                <div class="data-header">Project Terms</div>
                                <div class="project-description-data-wrapper" id="project_terms"
                                    :class="{'no-data': !projectDetails.basicInfo || (projectDetails.basicInfo && !projectDetails.basicInfo.terms),
                                             'loading': descriptionLoading,
                                             'no-read-more': !isLongText('project_terms')}">
                                    <div v-if="descriptionLoading" class="loading"><span class="loader">Loading...</span></div>
                                    <div class="project-description-data" v-if="projectDetails.basicInfo && projectDetails.basicInfo.terms && projectDetails.basicInfo.terms.length > 0">
                                        <div class="data">
                                            <template v-for="(term, index) in projectDetails.basicInfo.terms" v-bind:key="'term' + index">
                                                <span class="term" v-html="getHighlightedText(term)"></span>
                                            </template>
                                        </div>
                                    </div>
                                    <div v-else-if="!descriptionLoading">No Project Terms available.</div>
                                    <button class="project-button" @click.prevent="expandDescription('project_terms')" v-if="projectDetails.basicInfo && projectDetails.basicInfo.terms && isLongText('project_terms')">Read
                                        <span v-if="!expanded['project_terms']">More</span><span v-else>Less</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="project-description sidebar-sections" id="details">
                            <div class="section-header">
								<i class="far fa-file-alt header-icon"></i>
                                <span>Details</span>
                            </div>

                            <div class="data-section" :class="{'loading-data': projectDetailsLoading}" v-if="projectDetailsLoading" >
                                <div class="loading"><span class="loader">Loading...</span></div>
                            </div>
                            <div v-else-if="!projectDetails.basicInfo" class=" data-section tableOnly">
                                <div class="no-data">No information available
                                    {{getProjectNumber()}}</div>
                            </div>
                            <div class="row col-data">
                                <div class="col-md-4 col-sm-12 data-section" v-if="projectDetails.basicInfo && projectDetails.basicInfo.contact_pi && projectDetails.basicInfo.contact_pi.profile_id">
                                    <div class="data-header">Contact PI/ Project Leader</div>
                                    <div class="detailed-info">
                                        <div class="data-label">Name</div>
                                        <div class="data-info">
                                            <a href @click.prevent="openPersonSummary(projectDetails.basicInfo.contact_pi.profile_id)" rel="noopener" class="text-decoration-none">{{projectDetails.basicInfo.contact_pi.full_name}} <i class="fa fa-external-link-alt widget-button-icon icon-exit-link widget-button-icon icon-exit-link" alt="Popout"/></a>
                                        </div>

                                        <div class="data-label">Title</div>
                                        <div class="data-info">
                                            {{projectDetails.basicInfo.contact_pi.title}}
                                        </div>

                                        <div class="data-label">Contact</div>
                                        <div class="data-info">
                                            <button class="project-button" @click.prevent="captchaTest" v-if="!emailPI && projectDetails.basicInfo.contact_pi.full_name">View Email
                                            </button>
                                            <template v-if="emailPI">
                                                <a v-if="emailPI !== 'Email not available'" :href="'mailTo:' + emailPI">{{emailPI}}</a>
                                                <template v-else>{{emailPI}}</template>
                                            </template>
                                            <template v-if="!projectDetails.basicInfo.contact_pi.full_name">
                                              Email not available
                                            </template>

                                            <label for="g-recaptcha-response" class="sr-only">c</label>
                                            <div id="recaptcha-container"></div>


                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-4 col-sm-12 data-section" v-if="projectDetails.basicInfo">
                                    <div class="data-header">Other PIs</div>
                                    <div class="detailed-info" v-if="projectDetails.basicInfo && projectDetails.basicInfo.others_pis && projectDetails.basicInfo.others_pis.length > 0">
                                        <div class="data-label">Name</div>
                                        <div class="data-info">
                                            <template v-for="(pi, index) in projectDetails.basicInfo.others_pis" v-bind:key="'pi-' + index">
                                                <a class="term text-decoration-none" href @click.prevent="openPersonSummary(pi.profile_id)" rel="noopener">{{pi.full_name}} <i class="fa fa-external-link-alt widget-button-icon icon-exit-link widget-button-icon icon-exit-link" alt="Popout"/></a>
                                            </template>
                                        </div>
                                    </div>
                                    <div class="detailed-info" v-else>Not Applicable</div>
                                </div>
                                
                                <div class="col-md-4 col-sm-12 data-section" v-if="projectDetails.basicInfo">
                                    <div class="data-header">Program Official</div>
                                    <div class="detailed-info">
                                        <div class="data-label">Name</div>
                                        <div class="data-info">
                                            {{projectDetails.basicInfo.po_name}}
                                        </div>

                                        <div class="data-label">Contact</div>
                                        <div class="data-info">
                                            <button class="project-button" v-if="!emailPO && projectDetails.basicInfo.po_name" @click.prevent="captchaTest">View Email
                                            </button>
                                            <template v-if="emailPO">
                                                <a v-if="emailPO !== 'Email not available'" :href="'mailTo:' + emailPO" rel="noopener">{{emailPO}}</a>
                                                <template v-else>{{emailPO}}</template>
                                            </template>
                                            <template v-if="!projectDetails.basicInfo.po_name">
                                              Email not available
                                            </template>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="project-description" v-if="projectDetails.basicInfo && projectDetails.basicInfo.organization">
                                <div class="row data-section box">
                                    <div class="data-header col-md-12">Organization</div>
                                    <div class="col-md-4 data-section">
                                        <div class="detailed-info">
                                            <div class="data-label">Name</div>
                                            <div class="data-info">
                                                {{projectDetails.basicInfo.organization.org_name}}
                                            </div>

                                            <div class="data-label">City</div>
                                            <div class="data-info">
                                                {{projectDetails.basicInfo.organization.org_city}}
                                            </div>

                                            <div class="data-label">Country</div>
                                            <div class="data-info">
                                                {{projectDetails.basicInfo.organization.org_country}} <template v-if="projectDetails.basicInfo.organization.org_fips">({{projectDetails.basicInfo.organization.org_fips}})</template>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-md-4 data-section">
                                        <div class="detailed-info">
                                            <div class="data-label">Department Type</div>
                                            <div class="data-info" v-if="projectDetails.basicInfo && projectDetails.basicInfo.organization && projectDetails.basicInfo.organization.dept_type">{{projectDetails.basicInfo.organization.dept_type}}</div>  
                                            <div class="data-info" v-else-if="!projectDetails.basicInfo || !projectDetails.basicInfo.organization || !projectDetails.basicInfo.organization.dept_type">Unavailable</div>

                                            <div class="data-label">Organization Type</div>
                                            <div class="data-info">
                                            <div class="data-info" v-if="projectDetails.basicInfo && projectDetails.basicInfo.organization_type">{{projectDetails.basicInfo.organization_type.name}}</div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-md-4 data-section">
                                        <div class="detailed-info">
                                            <div class="data-label">State Code</div>
                                            <div class="data-info" v-if="projectDetails.basicInfo && projectDetails.basicInfo.cong_dist && projectDetails.basicInfo.cong_dist.indexOf('-') > 0">
                                                {{projectDetails.basicInfo.cong_dist.substring(0, projectDetails.basicInfo.cong_dist.indexOf('-'))}}
                                            </div>
                                            <div class="data-label">Congressional District</div>
                                            <div class="data-info" v-if="projectDetails.basicInfo && projectDetails.basicInfo.cong_dist && projectDetails.basicInfo.cong_dist.indexOf('-') > 0">
                                                {{projectDetails.basicInfo.cong_dist.substring(projectDetails.basicInfo.cong_dist.indexOf('-') + 1)}}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="project-description " v-if="projectDetails.basicInfo" id="other-information">
                                <div class="row data-section box">
                                    <div class="data-header col-md-12">Other Information</div>
                                    <div class="col-md-4 data-section">
                                        <div class="detailed-info">
                                            <div class="data-label">Opportunity Number</div>
                                            <div class="data-info" v-if="projectDetails.basicInfo">
                                                <template v-if="projectDetails.basicInfo.full_foa && projectDetails.basicInfo.full_foa.toUpperCase().indexOf('OTA') === -1">
                                                        <a :href="projectDetails.basicInfo.foa_url" target="_blank" rel="noopener">{{projectDetails.basicInfo.full_foa}}</a>
                                                </template>
                                                <template v-else>{{projectDetails.basicInfo.full_foa}}</template>
                                            </div>

                                            <div class="data-label">Study Section</div>
                                            <div class="data-info" v-if="projectDetails.basicInfo && projectDetails.basicInfo.full_study_section"><a :href="projectDetails.basicInfo.full_study_section.url" target="_blank" rel="noopener">{{projectDetails.basicInfo.full_study_section.name}}</a></div>

                                            <div class="sub-col ">
                                                <div class="data-label">Fiscal Year</div>
                                                <div class="data-info" v-if="projectDetails.basicInfo">{{projectDetails.basicInfo.fiscal_year}}</div>
                                            </div>
                                            <div class="sub-col">
                                                <div class="data-label">Award Notice Date</div>
                                                <div class="data-info" v-if="projectDetails.basicInfo">{{filters.formatDate(projectDetails.basicInfo.award_notice_date, 'dd-MON-yyyy')}}</div>
                                            </div>
                                       
                                            <div class="row mt-2" v-if="projectDetails.basicInfo && projectDetails.basicInfo.post_award_action_type">
                                                <div class="data-label" v-if="projectDetails.basicInfo.post_award_action_type.amendment_type_long_name">Post Award Action Type</div>
                                                <div class="data-info">{{projectDetails.basicInfo.post_award_action_type.amendment_type_long_name}}</div>
                                            </div> 
                                          
                                        </div>
                                    </div>

                                    <div class="col-md-4 data-section">
                                        <div class="detailed-info">
                                            <div class="data-label">Administering Institutes or Centers</div>
                                            <div class="data-info">
                                                <template  v-if="projectDetails.basicInfo && projectDetails.basicInfo.agency_ic_admin">{{projectDetails.basicInfo.agency_ic_admin.name}}</template>
                                            </div>

                                            <div class="sub-col">
                                                <div class="data-label">CFDA Code</div>
                                                <div class="data-info" v-if="projectDetails.basicInfo">{{projectDetails.basicInfo.cfda_code}}</div>
                                            </div>

                                            <div class="mt-2">
                                                <div class="row">
                                                    <div class="col-sm-12 col-md-6 col-lg-6">
                                                        <div class="data-label">DUNS Number</div>
                                                        <div class="data-info mb-1" v-if="projectDetails.basicInfo && projectDetails.basicInfo.organization && projectDetails.basicInfo.organization.primary_duns">{{projectDetails.basicInfo.organization.primary_duns}}</div>
                                                    </div>
                                                    <div class="col-sm-12 col-md-6 col-lg-6">
                                                        <div class="data-label">UEI</div>
                                                        <div class="data-info mb-1" v-if="projectDetails.basicInfo && projectDetails.basicInfo.organization && projectDetails.basicInfo.organization.primary_uei">{{projectDetails.basicInfo.organization.primary_uei}}</div>
                                                    </div>
                                                </div>
                                                <div class="project-description-data-wrapper duns-uei-number" v-if="projectDetails.basicInfo.duns_uei_pairs" :class="{'loading': descriptionLoading,
                                                                        'no-read-more': !isLongText('DUNS_UEI_numbers')}" id="DUNS_UEI_numbers">
                                                    <div class="project-description-data duns-uei-number">
                                                        <div class="data">
                                                                <div class="row" v-for="(eachrow, eachindex) in projectDetails.basicInfo.duns_uei_pairs.split(';')">
                                                                    <div class="col-sm-12 col-md-6 col-lg-6">{{eachrow.split('-')[0]}}</div>
                                                                    <div class="col-sm-12 col-md-6 col-lg-6">{{eachrow.split('-')[1]}}</div>
                                                                </div>
                                                        </div>
                                                    </div>
                                                    <button class="project-button" @click.prevent="expandDescription('DUNS_UEI_numbers')" v-if="isLongText('DUNS_UEI_numbers')">View
                                                        <span v-if="!expanded['DUNS_UEI_numbers']">All</span><span v-else>Less</span>
                                                    </button>
                                                </div>
                                            </div>
                             
                                            <div class="sub-col">
                                                <div class="data-label"></div>
                                                <div class="data-info"></div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-md-4 data-section ">
                                        <div class="sub-col inline-value">
                                            <div class="row mt-2">
                                                <div class="col-sm-12 col-md-6 col-lg-6">Project Start Date</div>
                                                <div class="col-sm-12 col-md-6 col-lg-6 font-weight-bold" v-if="projectDetails.basicInfo">
                                                    {{ filters.formatDate(projectDetails.basicInfo.project_start_date, 'dd-MON-yyyy')}}
                                                </div>
                                            </div>
                                            <div class="row mt-2">
                                                <div class="col-sm-12 col-md-6 col-lg-6">Project End Date</div>
                                                <div class="col-sm-12 col-md-6 col-lg-6 font-weight-bold" v-if="projectDetails.basicInfo">
                                                    {{ filters.formatDate(projectDetails.basicInfo.project_end_date, 'dd-MON-yyyy')}}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="sub-col inline-value">
                                            <div class="row mt-2">
                                                <div class="col-sm-12 col-md-6 col-lg-6">Budget Start Date</div>
                                                <div class="col-sm-12 col-md-6 col-lg-6 font-weight-bold" v-if="projectDetails.basicInfo">
                                                    {{ filters.formatDate(projectDetails.basicInfo.budget_start, 'dd-MON-yyyy')}}
                                                </div>
                                            </div>
                                            <div class="row mt-2">
                                                <div class="col-sm-12 col-md-6 col-lg-6">Budget End Date</div>
                                                <div class="col-sm-12 col-md-6 col-lg-6 font-weight-bold" v-if="projectDetails.basicInfo">
                                                    {{ filters.formatDate(projectDetails.basicInfo.budget_end, 'dd-MON-yyyy')}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="project-description " v-if="projectDetails.basicInfo" id="funding-information">
                                <div class="row data-section box">
                                    <div class="data-header col-md-12">Project Funding Information <template v-if="projectDetails.basicInfo.fiscal_year"> for {{projectDetails.basicInfo.fiscal_year}}</template></div>
                                    <div class=" col-md-12   data-section" v-if="projectDetails.basicInfo && projectDetails.basicInfo.agency_ic_admin &&  projectDetails.basicInfo.agency_ic_admin.name.toLowerCase() === 'veterans affairs'">
                                        <a :href="externalURLs.va_url" v-if="externalURLs && externalURLs.va_url" target="_blank" rel="noopener">Funded VA Research Projects</a>
                                    </div>
                                    <div v-else class="col-md-12">
                                        <div class="row">
                                            <div class="col-md-4 data-section">
                                                <div class="detailed-info">
                                                    <div class="data-label">Total Funding</div>
                                                    <div class="data-info" v-if="projectDetails.basicInfo.award_amount">{{ filters.globalFormat(projectDetails.basicInfo.award_amount, '$')}}</div>
                                                </div>
                                            </div>

                                            <div class="col-md-4 data-section">
                                                <div class="detailed-info">
                                                    <div class="data-label">Direct Costs</div>
                                                    <div class="data-info" v-if="projectDetails.basicInfo.direct_cost_amt">{{ filters.globalFormat(projectDetails.basicInfo.direct_cost_amt, '$')}}</div>
                                                </div>
                                            </div>

                                            <div class="col-md-4 data-section">
                                                <div class="detailed-info">
                                                    <div class="data-label">Indirect Costs</div>
                                                    <div class="data-info" v-if="projectDetails.basicInfo.indirect_cost_amt">
                                                        {{ filters.globalFormat(projectDetails.basicInfo.indirect_cost_amt, '$')}}
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-md-12 data-section tableOnly">
                                                <dataTable :table="projectFunding" id="fundingDataTable" fromPage="projectDetails" ref="fundingDataTable" isFixedTable="true" ></dataTable>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                             <div class="project-description " v-if="projectDetails.basicInfo && projectDetails.basicInfo.categorical_spending && projectDetails.basicInfo.categorical_spending.length > 0" id="spendingCategory-information">
                                <div class="row data-section box">
                                    <div class="data-header col-md-12">NIH Categorical Spending<a
                                            v-bind:href="externalURLs.report_base_url + externalURLs.report_categorical_spending_url"
                                            target="_blank" class="help-link text-decoration-none">Click here for more information on NIH
                                            Categorical Spending</a></div>
                                    <div class="col-md-12 data-section tableOnly">
                                        <table class="data-table">
                                            <thead>
                                            <tr>
                                                <th>Funding IC</th>
                                                <th>FY&nbsp;Total&nbsp;Cost&nbsp;by&nbsp;IC</th>
                                                <th>NIH Spending Category</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr v-for="(category, index) in projectDetails.basicInfo.categorical_spending" v-bind:key="'spending_categories' + index">
                                                <td class="no-break" data-label="Funding IC">{{category.funding_ic}}</td>
                                                <td data-label="FY Total Cost by IC">{{ filters.globalFormat(category.total_cost, '$')}}</td>
                                                <td data-label="NIH Spending Category">
                                                    <template v-for="(term, index1) in category.spending_categories" v-bind:key="'category' + index1">
                                                        <span class="term">{{term}}</span><template v-if="index1 < category.spending_categories.length - 1">; </template>
                                                    </template>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="project-description sidebar-sections" id="sub-Projects">
                            <div class="section-header">
                                <div class="row">
                                    <div class="col-6">
										<i class="fa fa-sitemap header-icon"></i>
                                        <span>Sub Projects</span>
                                    </div>

                                    <div class="col-6">
                                     <b-button variant="light"
                                        v-if="projectDetails.subProjects && projectDetails.subProjects.results.length > 0"
                                        @click.prevent="initExport('subProjects')"
                                        class="button-export"
                                        >
                                            <i class="fas fa-download"></i>
                                            <span class="btn-text ms-2 font-weight-bold">Export</span>
                                    </b-button>
                                    </div>
                                </div>
                            </div>
                            <div class="data-section tableOnly" id="subProjectsDataTableContainer" :class="{'loading-data': subProjectsLoading}">
                                <div v-if="subProjectsLoading" class="loading"><span class="loader">Loading...</span></div>
                                    <dataTable class="dataTable" id="subProjectsDataTable" :table="detailsSubProjectsTable" containerScrolling="true" fromPage="projectDetails"  ref="subProjectsDataTable" v-if="projectDetails.subProjects && projectDetails.subProjects.results.length > 0"></dataTable>
                                    <div class="no-data" v-else-if="!this.subProjectsLoading">No Sub Projects information available {{getProjectNumber()}}</div>
                            </div>
                        </div>

                        <div class="project-description sidebar-sections" id="publications">
                            <div class="section-header">
								<i class="fa fa-book-open header-icon"></i>
                                <span>Publications</span>
                                <div class="float-end mt-3"><b-button v-b-toggle.publicationsNotes  variant="outline-dark">
                                    <strong><i class="fas fa-angle-right me-2"></i>Disclaimer</strong></b-button>
                                </div>
                                <button v-if="projectDetails.publications && projectDetails.publications.results.length > 0" class="button-with-svg button-export me-2" @click.prevent="exportSectionData('publications')">
                                    <i class="fas fa-download"></i>
                                    <span class="btn-text ms-2 font-weight-bold">Export</span>
                                </button>
                            </div>
                            <b-collapse id="publicationsNotes"><div class="pt-1 pb-3 small ">Publications are associated with projects, but cannot be identified with any particular year of the project or fiscal year of funding. This is due to the continuous and cumulative nature of knowledge generation across the life of a project and the sometimes long and variable publishing timeline. Similarly, for multi-component projects, publications are associated with the parent core project and not with individual sub-projects.</div></b-collapse>
                            <div class="data-section tableOnly"  id="pubDataTableContainer" :class="{'loading-data': publicationsLoading}">
                                <div v-if="publicationsLoading" class="loading"><span class="loader">Loading...</span></div>
                                <pubDataTable class="dataTable" id="pubDataTable" v-on:sort-column="setSortDetails" :table="detailsPublicationTable" containerScrolling="true" fromPage="projectDetails"  ref="pubDataTable" v-if="projectDetails.publications && projectDetails.publications.results.length > 0" />
                                <div class="no-data" v-else-if="!this.publicationsLoading">No Publications available {{getProjectNumber()}}</div>
                            </div>
                        </div>

                        <div class="project-description sidebar-sections" id="patents">
                            <div class="section-header">
								<i class="far fa-lightbulb header-icon"></i>
                                <span>Patents</span>
                                <button v-if="projectDetails.patents && projectDetails.patents.results.length > 0" class="button-with-svg button-export" @click.prevent="exportSectionData('patents')">
                                    <i class="fas fa-download"></i>
                                    <span class="btn-text ms-2 font-weight-bold">Export</span>
                                </button>
                            </div>
                            <div class="data-section tableOnly"  id="patentsDataTableContainer" :class="{'loading-data': patentsLoading}">
                                <div v-if="patentsLoading" class="loading"><span class="loader">Loading...</span></div>
                                <dataTable class="dataTable" id="patentsDataTable" :table="detailsPatentTable" containerScrolling="true" fromPage="projectDetails"  ref="patentsDataTable" v-if="projectDetails.patents && projectDetails.patents.results.length > 0" />
                                <div class="no-data" v-else-if="!this.patentsLoading">No Patents information available {{getProjectNumber()}}</div>
                            </div>
                        </div>

                        <div class="project-description sidebar-sections" id="outcomes">
                            <div class="section-header">
								<i class="fas fa-chart-line header-icon"></i>
                                <span>Outcomes</span>
                            </div>
                            <div class="data-section" :class="{'loading-data': outcomesLoading}">
                                <!-- v-if="projectDetails.projectOutcomes && projectDetails.projectOutcomes.outcomes_text"  -->
                                <div class="disclaimer">The Project Outcomes shown here are displayed verbatim as submitted by the Principal Investigator (PI) for this award. Any opinions, findings, and conclusions or recommendations expressed are those of the PI and do not necessarily reflect the views of the National Institutes of Health. NIH has not endorsed the content below.</div>
                                <div>
                                    <div v-if="outcomesLoading" class="loading"><span class="loader">Loading...</span></div>
                                    <div v-if="projectDetails.projectOutcomes && projectDetails.projectOutcomes.outcomes_text">{{projectDetails.projectOutcomes.outcomes_text}}</div>
                                    <div class="no-data" v-else-if="!outcomesLoading">No Outcomes available {{getProjectNumber()}}</div>
                                </div>
                            </div>
                        </div>

                        <div class="project-description sidebar-sections" id="clinical-studies">
                            <div class="section-header">
								<i class="fab fa-readme header-icon"></i>
                                <span>Clinical Studies</span>
                                <button v-if="projectDetails.clinicalStudies && projectDetails.clinicalStudies.results.length > 0" class="button-with-svg button-export" @click.prevent="exportSectionData('clinicalStudies')">
                                    <i class="fas fa-download"></i>
                                    <span class="btn-text ms-2 font-weight-bold">Export</span>
                                </button>
                            </div>
                            <div class="data-section tableOnly"  id="clinicalStudiesDataTableContainer" :class="{'loading-data': clinicalStudiesLoading}">
                                <div v-if="clinicalStudiesLoading" class="loading"><span class="loader">Loading...</span></div>
                                <dataTable class="dataTable" id="clinicalStudiesDataTable" :table="detailsClinicalStudiesTable" containerScrolling="true" fromPage="projectDetails"  ref="clinicalStudiesDataTable" v-if="projectDetails.clinicalStudies && projectDetails.clinicalStudies.results.length > 0" />
                                <div class="no-data" v-else-if="!this.clinicalStudiesLoading">No Clinical Studies information available {{getProjectNumber()}}</div>
                            </div>
                        </div>

                        <div class="project-description sidebar-sections" id="news">
                            <div class="section-header">
								<i class="far fa-newspaper header-icon"></i>
                                <span>News and More</span>
                            </div>
                            <div class="news-data-section">
                                <div class="news-header">Related News Releases</div>
                                <div class="data-section tableOnly"  id="newsResultsDataTableContainer" :class="{'loading-data': newsInfoLoading}">
                                    <div v-if="newsInfoLoading" class="loading"><span class="loader">Loading...</span></div>
                                    <dataTable class="dataTable" id="PressReleaseDataTable" :table="detailsPressReleaseTable" containerScrolling="true" fromPage="projectDetails"  ref="PressReleaseDataTable" v-if="projectDetails.PressRelease && projectDetails.PressRelease.length > 0" />
                                    <div class="no-data" v-else-if="!this.newsInfoLoading">No news release information available {{getProjectNumber()}}</div>
                                </div>
                            </div>
                            <div class="news-data-section" v-if="projectDetails.ResearchMatters && projectDetails.ResearchMatters.length > 0">
                                <div class="news-header">Related NIH Research Matters</div>
                                <div class="data-section tableOnly"  id="newsResultsDataTableContainer"  >
                                    <dataTable class="dataTable" id="ResearchMattersDataTable" :table="detailsResearchMattersTable" containerScrolling="true" fromPage="projectDetails"  ref="ResearchMattersDataTable" v-if="projectDetails.ResearchMatters && projectDetails.ResearchMatters.length > 0" />
                                </div>
                            </div>
                            <div class="news-data-section" v-if="projectDetails.AIRS && projectDetails.AIRS.length > 0" >
                                <div class="news-header">Related NIH Recovery Act Investment Reports</div>
                                <div class="data-section tableOnly"  id="newsResultsDataTableContainer">
                                    <dataTable class="dataTable" id="AIRSDataTable" :table="detailsAIRSTable" containerScrolling="true" fromPage="projectDetails"  ref="AIRSDataTable" v-if="projectDetails.AIRS && projectDetails.AIRS.length > 0" />
                                </div>
                            </div>
                            <div class="news-data-section" v-if="projectDetails.ARRA && projectDetails.ARRA.length > 0" >
                                <div class="news-header">Related ARRA Impact Reports</div>
                                <div class="data-section tableOnly"  id="newsResultsDataTableContainer">
                                    <dataTable class="dataTable" id="ARRADataTable" :table="detailsARRATable" containerScrolling="true" fromPage="projectDetails"  ref="ARRADataTable" v-if="projectDetails.ARRA && projectDetails.ARRA.length > 0" />
                                </div>
                            </div>
                            <div class="news-data-section" v-if="projectDetails.AIMRS && projectDetails.AIMRS.length > 0" >
                                <div class="news-header">Related ARRA Impact Reports</div>
                                <div class="data-section tableOnly"  id="newsResultsDataTableContainer">
                                    <dataTable class="dataTable" id="AIMRSTableDataTable" :table="detailsAIMRSTable" containerScrolling="true" fromPage="projectDetails"  ref="AIMRSDataTable" v-if="projectDetails.AIMRS && projectDetails.AIMRS.length > 0" />
                                </div>
                            </div>
                        </div>

                        <div class="project-description sidebar-sections" id="history">
                            <div class="section-header history">
								<i class="fas fa-history menu-icon header-icon"></i>
                                <span>History</span>
                                <div class="note" v-if="projectDetails.history && projectDetails.history.meta  && 
                                     projectDetails.history.results.length > 0 && !isHrsaOrVaProjects(projectDetails.history.results[0].admin_icd_long_abbr)">Total project funding amount for {{projectDetails.history.meta.total}} project<template v-if="projectDetails.history && projectDetails.history.meta.total > 1">s</template> is {{ filters.globalFormat(parseInt(projectDetails.history.meta.properties.TotalFunding), '$')}}*
                                    <div class="sub-note">* Only NIH, CDC and FDA funding data</div>
                                </div>

                                <b-button variant="light"
                                    v-if="projectDetails.history && projectDetails.history.results.length > 0"
                                    @click.prevent="initExport('projectHistory')"
                                    class="button-export"
                                    >
                                        <i class="fas fa-download"></i>
                                        <span class="btn-text ms-2 font-weight-bold">Export</span>
                                </b-button>

                            </div>
                            <div class="data-section tableOnly" id="historyDataTableContainer" :class="{'loading-data': historyLoading, 'noData': (!projectDetails.history || projectDetails.history.results.length === 0) && !historyLoading }">
                                <div v-if="historyLoading" class="loading"><span class="loader">Loading...</span></div>
                                <dataTable class="dataTable" id="historyDataTable" :table="detailsHistoryTable" containerScrolling="true" fromPage="projectDetails"  ref="historyDataTable" v-if="projectDetails.history && projectDetails.history.results.length > 0"></dataTable>
                                <div class="no-data" v-else-if="!historyLoading">No Historical information available {{getProjectNumber()}}</div>
                            </div>
                        </div>

                        <div class="project-description sidebar-sections" id="similar-Projects">
                            <div class="section-header">
								<i class="fas fa-project-diagram header-icon"></i>
                                <span>Similar Projects</span>
                            </div>
                            <div class="data-section tableOnly" id="similarProjectsDataTableContainer" :class="{'loading-data': similarProjectsLoading, 'noData': (!projectDetails.similarProjects || projectDetails.similarProjects.results.length === 0) && !similarProjectsLoading }">
                                <div v-if="similarProjectsLoading" class="loading"><span class="loader">Loading...</span></div>
                                <dataTable class="dataTable" id="similarProjectsDataTable" :table="detailsSimilarProjectsTable" containerScrolling="true" fromPage="projectDetails"  ref="similarProjectsDataTable" v-if="projectDetails.similarProjects && projectDetails.similarProjects.results.length > 0"></dataTable>
                                <div class="no-data" v-else-if="!similarProjectsLoading">No Similar Projects information available {{getProjectNumber()}}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else-if="invalidProjectNumber" class="project-details" >
                    <div class=" mx-4 mt-3">
                        <b-alert show variant="warning">Invalid project identifier.</b-alert>
                    </div>
                </div>
                <div v-else class="project-details" >
                    <div class=" mx-4 mt-3">
                        <b-alert show variant="warning">This project doesn't exist in RePORTER yet. Please check your query or check back after the start date.</b-alert>
                    </div>
                </div>
            </div>
        </div>

        <!-- Export -->
        <exportModule ref="exportModule" fromPage="projectDetails" :exportSectionName="exportSectionName" :exportModuleName="exportModuleName" />
   </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import navigationTabs from '@/components/global/navigationTabs.vue';
import searchCriteria from '@/components/global/searchCriteria.vue';
import dataTable from '@/components/global/dataTable.vue';
import pubDataTable from '@/components/global/pubDataTable.vue';
import globalMixins from '@/globalMixins';
import projectListMixins from '@/projectListMixins';
import exportModule from  '@/components/global/export.vue';
import breakpoints from "@/shared/breakpoints.utils.js";
import {app} from '@/main';
import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
import bus from '@/shared/event-bus.js';

export default {
    name: 'projectDetailsPage',
    mixins: [globalMixins, projectListMixins],
    components: {
      navigationTabs,
      searchCriteria,
      dataTable,
      pubDataTable,
      exportModule
    },
    computed: {
        ...mapGetters([
            'searchMeta',
            'projectDetails',
            'searchFacetCriteria',
            'isExportingFile',
            'searchType',
			'externalURLs',
            'invalidProjectIdMsg'
        ]),
        breakpoints: () => breakpoints.screen
    },
    data: function () {
        return {
            loading: false,
            exportModuleName: '',
            exportSectionName: '',
            expanded: {
                'abstract_text': false,
                'relevance_statement': false,
                'spending_categories': false,
                'project_terms': false,
                'DUNS_UEI_numbers': false
            },
            selectedSection: 'description',
            projectFunding: {
                name: 'Projects',
                totalCount: 0,
                columns: {
                    year: {
                        displayName: 'Year',
                        fieldName: 'fy',
                        rowData: false,
                        isVisible: true,
                        isSortable: false
                    },
                    fundingIC: {
                        displayName: 'Funding IC',
                        fieldName: 'name',
                        rowData: false,
                        isVisible: true,
                        isSortable: false
                    },
                    awardAmountbyIC: {
                        displayName: 'FY Total Cost by IC',
                        fieldName: 'total_cost',
                        rowData: false,
                        isVisible: true,
                        isSortable: false,
                        formatType: '$'
                    }
                },
                sortField: ''
            },
            basicInfoLoading: false,
            descriptionLoading: false,
            projectDetailsLoading: false,
            publicationsLoading: false,
            patentsLoading: false,
            historyLoading: false,
            subProjectsLoading: false,
            outcomesLoading: false,
            detailsPublicationTable: null,
            detailsPatentTable: null,
            detailsHistoryTable: null,
            detailsSubProjectsTable: null,
            detailsClinicalStudiesTable: null,
            detailsSimilarProjectsTable: null,
            detailsPressReleaseTable: null,
            detailsResearchMattersTable: null,
            detailsAIRSTable: null,
            detailsARRATable: null,
            detailsAIMRSTable: null,
            emailPI: null,
            emailPO: null,
            clinicalStudiesLoading: false,
            similarProjectsLoading: false,
            newsInfoRequested: false,
            newsInfoLoading: false,
            stopWords: [
                "a",
                "an",
                "and",
                "are",
                "as",
                "at",
                "be",
                "but",
                "by",
                "for",
                "if",
                "in",
                "into",
                "is",
                "it",
                "no",
                "not",
                "of",
                "on",
                "or",
                "such",
                "that",
                "the",
                "their",
                "then",
                "there",
                "these",
                "they",
                "this",
                "to",
                "was",
                "will",
                "with"
            ],
            userScrollStarted: false,
            shareCopyURL: '',
            shareEmailURL: '',
            projectNotAvailable: false,
            invalidProjectNumber: false,
            filters: app.$options.$filters
        }
    },
    watch: {
        // call again the method if the route changes
        '$route': function (val, oldVal) {
            if (val.params.appl_id !== oldVal.params.appl_id) {
                let activeTab = document.querySelector('.sidebar a.active');
                if (activeTab) {
                    activeTab.classList.remove('active');
                }
                this.loadInitialPage();
            }
        },
        'projectDetails.basicInfo': function (val) {
            if (val) {
                this.setShareURL();
                let hashLnk = this.$route.hash !== '' ? this.$route.hash.replace(/[^a-zA-Z-]/gi, '') : this.breakpoints.lt.md ? 'description' : '',
                    self = this;
                setTimeout(() => {
                    if (hashLnk !== '') {
                        self.goTo(hashLnk);
                    }
                }, 501);

            }
        }
    },
    async mounted () {
     window.scrollTo(0, 0);
     this.filters = app.$options.$filters;
        
	 var requestedURLs = [
        ];
        if (!this.externalURLs || !this.externalURLs.va_url) {
            requestedURLs.push('va_url')
        }
        if (!this.externalURLs || !this.externalURLs.report_categorical_spending_url) {
            requestedURLs.push('report_categorical_spending_url');
        }
        if (!this.externalURLs || !this.externalURLs.reporter_nidb_report_url) {
            requestedURLs.push('reporter_nidb_report_url');
        }
		if (requestedURLs.length > 0) {
			await this.$store.dispatch('getAppSettingsPropertyByNameAction', requestedURLs);
		}
        
        bus.$off('get-applId');
        bus.$on('get-applId', (data, callback) => {
            this.getApplId(data, callback)
        });
        bus.$off('sort-column');
        bus.$on('sort-column', ($e1, data) => {
            this.setSortDetails($e1, data)
        });
        
        this.loadInitialPage();
    },
    methods: {
        ...mapActions([
            'setProjectDetails',
            'updateProjectDetails',
            'resetProjectDetails'
        ]),
        getProjectNumber: function () {
            if (this.projectDetails.basicInfo) {
                let msg = 'for ' + this.projectDetails.basicInfo.project_num;

                if (this.projectDetails.basicInfo.subproject_id) {
                    msg += ' ' + this.projectDetails.basicInfo.subproject_id;
                }
                return msg;
            }
            return '';
        },
        setShareURL () {
            var bodyMsg = 'Please click on link to view the NIH-funded research project: %0A' + this.projectDetails.basicInfo.project_title,
                mailText,
                subject = 'NIH RePORTER - Project Details',
                curURL = '';

            curURL = location.origin + '/project-details/' + this.$route.params.appl_id;
            this.shareCopyURL = curURL;

            curURL = curURL.replace(/%/g, '%25').replace(/\&/g, '%26').replace(/\s/g, '%20');
            mailText = 'mailto:?subject=' + subject.replace(/\s/g, '%20') + '  &body=' + bodyMsg.replace(/\s/g, '%20') + ' %0A%0A ' + curURL;
            this.shareEmailURL = mailText;
        },
        setParentProjectURL () {
            if (this.projectDetails.basicInfo && this.projectDetails.basicInfo.parent_appl_id) {
                var id = (new Date()).getTime(),
                parentProjWin = window.open(window.location.origin + '/project-details/' + this.projectDetails.basicInfo.parent_appl_id, id, "toolbar=1,scrollbars=1,location=0,statusbar=0,menubar=1,resizable=1,width=1000,height=600,left = 250,top =150");
            }
       },
        openPersonSummary (profile_id) {
            this.setPersonSummaryProjects(null);

            var id = (new Date()).getTime(),
            myWindow = window.open(window.location.origin + '/PISearch/' + profile_id, id, "toolbar=1,scrollbars=1,location=0,statusbar=0,menubar=1,resizable=1,width=1000,height=600,left = 250,top =150");
        },
        loadSectionData (section) {
            switch (section) {
                case 'details':
                    break; 
                case 'sub-Projects':
                    if (!this.projectDetails.subProjects && !this.subProjectsLoading) {
                        this.subProjectsLoading = true;
                        this.getProjectInfo(this.$route.params.appl_id, 'subProjects', this.handlSubProjects);
                    }
                    break;
                case 'publications':
                    if (!this.projectDetails.publications && !this.publicationsLoading) {
                        this.publicationsLoading = true;
                        this.getProjectInfo(this.$route.params.appl_id, 'publications', this.handlePublications);
                    }
                    break;
                case 'patents':
                    if (!this.projectDetails.patents && !this.patentsLoading) {
                        this.patentsLoading = true;
                        this.getProjectInfo(this.$route.params.appl_id, 'patents', this.handlePatents);
                    }
                    break;
                case 'outcomes':
                    if (!this.projectDetails.projectOutcomes && !this.outcomesLoading) {
                        this.outcomesLoading = true;
                        this.getProjectInfo(this.$route.params.appl_id, 'outcomes', this.handlOutcomes);
                    }
                    break;
                case 'history':
                    if (!this.projectDetails.history && !this.historyLoading) {
                        this.historyLoading = true;
                        this.getProjectInfo(this.$route.params.appl_id, 'projectHistory', this.handleProjectHistory);
                    }
                    break;
                case 'clinical-studies':
                    if (!this.projectDetails.clinicalStudies && !this.clinicalStudiesLoading) {
                        this.clinicalStudiesLoading = true;
                        this.getProjectInfo(this.$route.params.appl_id, 'clinicalStudies', this.handleClinicalStudies);
                    }
                    break;
                case 'similar-Projects':
                    if (!this.projectDetails.similarProjects && !this.similarProjectsLoading) {
                        this.similarProjectsLoading = true;
                        this.getProjectInfo(this.$route.params.appl_id, 'similarProjects', this.handleSimilarProjects);
                    }
                    break;
                case 'news':
                    if (!this.projectDetails.PressRelease && !this.newsInfoLoading) {
                        if (this.projectDetails.basicInfo) {
                            this.newsInfoLoading = true;

                            var fullProjNum = this.projectDetails.basicInfo.project_num,     // ARRA investment reports and stories using full project number
                                grantNum = fullProjNum.slice(4, 12); // Press release and Reseach Matters uses IC-SerialNumber

                            this.getProjectInfo(grantNum, 'PressRelease', this.handleNewsInfo);
                            this.getProjectInfo(grantNum, 'ResearchMatters', this.handleNewsInfo);
                            this.getProjectInfo(fullProjNum, 'AIRS', this.handleNewsInfo);
                            this.getProjectInfo(fullProjNum, 'ARRA', this.handleNewsInfo);
                            this.getProjectInfo(fullProjNum, 'AIMRS', this.handleNewsInfo);
                        } else {
                            this.newsInfoRequested = true;
                        }
                    }
            }
        },
        loadInitialPage () {
            window.scrollTo(0, 0);
            if (!this.$store.state.searchResults) {
                this.getSearchCriteria();
            }
            if (!this.$route.params.appl_id) {
                this.$router.push({ path: '/' });
            } else {
                var self = this,
                    hashLnk = this.$route.hash !== '' ? this.$route.hash.replace(/[^a-zA-Z-]/gi, '') : this.breakpoints.lt.md ? 'description' : '';

                this.loading = true;

                this.detailsPublicationTable = copyData(this.publicationTable);
                this.detailsPatentTable = copyData(this.patentTable);
                this.detailsHistoryTable = copyData(this.projectHistoryTable);
                this.detailsClinicalStudiesTable = copyData(this.clinicalStudyTable);
                this.detailsSubProjectsTable = copyData(this.subProjectsTable);
                this.detailsSimilarProjectsTable = copyData(this.similarProjectTable);
                this.detailsPressReleaseTable = copyData(this.PressReleaseTable);
                this.detailsResearchMattersTable = copyData(this.ResearchMattersTable);
                this.detailsAIRSTable = copyData(this.AIRSTable);
                this.detailsARRATable = copyData(this.ARRATable);
                this.detailsAIMRSTable = copyData(this.AIMRSTable);
                this.loadProjectInformation();
                if (hashLnk !== '') {
                    this.goTo(hashLnk);
                    this.selectedSection = hashLnk;
                }
            }
        },
        scrollToHashSection () {
            if (!this.userScrollStarted) {
                setTimeout(() => {
                    let hashLnk = this.$route.hash !== '' ? this.$route.hash.replace(/[^a-zA-Z-]/gi, '') : this.breakpoints.lt.md ? 'description' : ''
                    if (hashLnk) {
                        this.goTo(hashLnk);
                    }
                }, 101);
            }
        },
        initCaptcha () {
            grecaptcha.ready(() => {
                grecaptcha.render('recaptcha-container', {
                    sitekey: '6LdpQbMUAAAAAJZN02xaecwPWh7x6aQo3BDVDR7x',
                    size: 'invisible',
                    callback: this.loadEmails
                });
            });
        },
        loadEmails (token) {
            window.getCaptchaData({
                project_id: this.$route.params.appl_id,
                recaptcha: token
            }, this.parseEmails);
        },
        parseEmails (response) {
            if (response.PI) {
                this.emailPI = response.PI.email;
            } else {
                this.emailPI = 'Email not available';
            }

            if (response.PO) {
                this.emailPO = response.PO.email;
            } else {
                this.emailPO = 'Email not available';
            }
        },
        captchaTest () {
            grecaptcha.execute();
        },
        goTo (section) {
            let page = '',
                parentPage = 'search',
                currentView = 'projects',
                self = this;

            if (event) {
                event.preventDefault();
            }

            if (section === 'map' || section === 'charts') {
                page = section;
            }

            if (section === 'publications-tab') {
                currentView = 'publications';
            } else if (section === 'news-tab') {
                currentView = 'news';
            }

            if (this.$route.name === 'search-project-details-matchmaker') {
                parentPage = 'matchmaker';
            }
            if (this.$route.name ===  'publications-project-details') {
                parentPage = 'publications';
                currentView = '';
            }
            if (section === 'search-results' || section === 'map' || section === 'charts' || section === 'publications-tab' || section === 'news-tab') {
                if (event.ctrlKey || event.metaKey) {
                    let routeData = this.$router.resolve({path: '/' + parentPage + '/' + this.$route.params.search_id + '/' + currentView + (page ? '/' + page : page)});
                    window.open(routeData.href, '_blank');
                } else {

                    this.$router.push({
                        path: '/' + parentPage + '/' + this.$route.params.search_id + '/' + currentView + (page ? '/' + page : page)
                    }).catch(err => {})
                    // this.$router.back();
                }
            } else {
                let activeTab = document.querySelector('.sidebar a.active');

                if (!activeTab || (activeTab &&!activeTab.classList.contains('disabled'))) {
                    setTimeout(() => {
                        let fixedHeaderObj = document.getElementById('project-basics'),
                            fixedHeaderObjOffset = fixedHeaderObj.offsetHeight + 25, //padding botton value of entire section,
                            sysAppMessageOffset = document.getElementById('sysAppMessageContainer') ? document.getElementById('sysAppMessageContainer').offsetHeight : 0;
                        
                        if (document.getElementById(section)) {
                            if (fixedHeaderObj.classList.value.indexOf('fixed-head') !== -1) {
                                window.scrollTo(0, document.getElementById(section).offsetTop - fixedHeaderObjOffset + sysAppMessageOffset);
                            } else {
                                window.scrollTo(0, document.getElementById(section).offsetTop - (2 * fixedHeaderObjOffset) + sysAppMessageOffset);
                            }
                        }
                        if (activeTab) {
                            activeTab.classList.remove('active');
                            document.querySelector(".sidebar a[href='#"+ section + "']").classList.add('active');
                        }
                        self.selectedSection = section;
                        self.$router.push({
                            hash: '#' + section
                        }).catch(()=>{});
                    }, 500);
                }
            }
        },
        loadProjectInformation () {
            this.resetProjectDetails(null);
            this.basicInfoLoading = true;
            this.getProjectInfo(this.$route.params.appl_id, 'basicInfo', this.handleProjectInfo);
        },
        handleProjectInfo (data) {
            this.basicInfoLoading = false;
            if (data && data.status === 204) {
                this.projectNotAvailable = true;
            } else if (data && data.status === 400) {
                this.projectNotAvailable = true;
                this.invalidProjectNumber = true;
            } else {
                this.setProjectDetails({
                    name: 'basicInfo',
                    data: data
                });
                setTimeout(() => {
                    this.initCaptcha();
                    this.$forceUpdate();
                }, 100); 
                if (this.newsInfoRequested) {
                    this.loadSectionData('news');
                }
            }
        },
        handlePublications (data) {
            this.detailsPublicationTable.columns.coreProjectNumber.isVisible = false;
            this.publicationsLoading = false;
            if (data && data.meta) {
                this.setProjectDetails({
                    name: 'publications',
                    data: data
                });
            }

            this.scrollToHashSection();
        },
        handlePatents (data) {
            this.patentsLoading = false;
            if (data && data.meta) {
                this.detailsPatentTable.columns.coreProjectNumber.isVisible = false;
                this.setProjectDetails({
                    name: 'patents',
                    data: data
                });
            }

            this.scrollToHashSection();
        },
        handleProjectHistory (data) {
            this.historyLoading = false;
            var col;


            if (data && data.meta) {
                if (this.detailsHistoryTable.offset === 0) {
                    this.detailsHistoryTable.offset = 0;
                    this.detailsHistoryTable.limit = 50;
                    // this.historyTable = data.results;
                    this.setProjectDetails({
                        name: 'history',
                        data: data
                    });
                } else {
                    this.detailsHistoryTable.loadingMoreData = false;
                    this.updateProjectDetails({
                        name: 'history',
                        data: data
                    });
                    this.$refs.detailsHistoryTable.initTableData();
                }
            }

            this.scrollToHashSection();
        },
        handlSubProjects (data) {
            this.subProjectsLoading = false;
            if (data && data.meta) {
                this.setProjectDetails({
                    name: 'subProjects',
                    data: data
                });
            }

            this.scrollToHashSection();
        },
        handlOutcomes (data) {
            this.outcomesLoading = false;
            if (data) {
                this.setProjectDetails({
                    name: 'projectOutcomes',
                    data: data
                });
            } else {
                this.setProjectDetails({
                    name: 'projectOutcomes',
                    data: []
                });
            }

            this.scrollToHashSection();
        },
        handleClinicalStudies (data) {
            this.clinicalStudiesLoading = false;
            var col;

            if (data && data.meta) {
                if (this.detailsClinicalStudiesTable.offset === 0) {
                    this.detailsClinicalStudiesTable.offset = 0;
                    this.detailsClinicalStudiesTable.limit = 50;
                    // this.historyTable = data.results;
                    this.setProjectDetails({
                        name: 'clinicalStudies',
                        data: data
                    });
                } else {
                    this.detailsClinicalStudiesTable.loadingMoreData = false;
                    this.updateProjectDetails({
                        name: 'clinicalStudies',
                        data: data
                    });
                    this.$refs.detailsClinicalStudiesTable.initTableData();
                }
            }
            this.scrollToHashSection();
        },
        handleNewsInfo (data, newsType) {
            this.detailsPressReleaseTable.columns.grant_num.isVisible = false;
            this.detailsPressReleaseTable.columns.news.isSortable = false;
            this.detailsPressReleaseTable.columns.date_added.isSortable = false;
            this.detailsPressReleaseTable.sortField = null;
            this.detailsResearchMattersTable.columns.grant_num.isVisible = false;
            this.detailsResearchMattersTable.columns.news.isSortable = false;
            this.detailsResearchMattersTable.columns.date_added.isSortable = false;
            this.detailsResearchMattersTable.sortField = null;
            this.detailsAIRSTable.columns.grant_num.isVisible = false;
            this.detailsAIRSTable.columns.news.isSortable = false;
            this.detailsAIRSTable.sortField = null;
            this.detailsARRATable.columns.grant_num.isVisible = false;
            this.detailsARRATable.columns.news.isSortable = false;
            this.detailsARRATable.sortField = null;
            this.detailsAIMRSTable.columns.grant_num.isVisible = false;
            this.detailsAIMRSTable.columns.news.isSortable = false;
            this.detailsAIMRSTable.sortField = null;
            this.newsInfoLoading = false;
            if (data) {
                this.setProjectDetails({
                    name: newsType,
                    data: data.results
                });
            }
            this.scrollToHashSection();
        },
        handleSimilarProjects (data) {
            this.similarProjectsLoading = false;
            var col;

            if (data && data.meta) {
                if (this.detailsSimilarProjectsTable.offset === 0) {
                    this.detailsSimilarProjectsTable.offset = 0;
                    this.detailsSimilarProjectsTable.limit = 50;
                    // this.historyTable = data.results;
                    this.setProjectDetails({
                        name: 'similarProjects',
                        data: data
                    });
                    if (this.$route.hash === '#similar-Projects') {
                        this.goTo('similar-Projects');
                    }
                } else {
                    this.detailsSimilarProjectsTable.loadingMoreData = false;
                    this.updateProjectDetails({
                        name: 'similarProjects',
                        data: data
                    });
                    this.$refs.detailsSimilarProjectsTable.initTableData();
                }
            }
            this.scrollToHashSection();
        },
        isLongText (id) {
            if (id === 'DUNS_UEI_numbers') {
                var dun_uei_nums = this.projectDetails.basicInfo && this.projectDetails.basicInfo.duns_uei_pairs ? this.projectDetails.basicInfo.duns_uei_pairs.split(';') : [];

                if (dun_uei_nums.length > 2) {
                    return true;
                }
                return false;
            } else {
                var descriptionContainer = document.getElementById(id),
                    reportFootnotes = descriptionContainer ? descriptionContainer.querySelector('.project-description-data') : null;

                if (reportFootnotes) {
                    if (descriptionContainer.getBoundingClientRect().height < reportFootnotes.getBoundingClientRect().height || this.expanded[id]) {
                        return true;
                    }
                }
                return false;
            }
        },
        expandDescription (id) {
            var descriptionContainer = document.getElementById(id),
                reportFootnotes = descriptionContainer.querySelectorAll('.project-description-data');

            if (!this.expanded[id]) {

                this.savedHeight = descriptionContainer.offsetHeight;

                descriptionContainer.style.height = this.savedHeight;

                this.$nextTick(() => {
                    descriptionContainer.style.cssText = {
                        height: reportFootnotes.offsetHeight,
                        'max-height': 'none'
                    }
                    descriptionContainer.classList.add('expanded');
                });
                this.expanded[id] = true;
            } else {
                descriptionContainer.style.height = this.savedHeight;

                this.$nextTick(() => {
                    descriptionContainer.classList.remove('expanded');
                });
                this.expanded[id] = false;
            }
        },
        setSortDetails ($event, selectedSortColumn) {
            var curSelected = window.closest($event.target, '.project-description'),
                dbSortField = this.getFieldNameFromSettings(selectedSortColumn),
                selectedSortField = selectedSortColumn.subField ? selectedSortColumn.fieldName + '[0].' + selectedSortColumn.subField : selectedSortColumn.fieldName,
                tableContainer,
                defaultRCRVal = '',
                self = this;

            if (curSelected) {
                switch(curSelected.getAttribute('id')) {
                    case 'history':
                        tableContainer = window.closest($event.target, '.data-section');
                        tableContainer.scrollTop = 0;
                        if (this.detailsHistoryTable.sortField === dbSortField) {
                            this.detailsHistoryTable.sortOrder = (this.detailsHistoryTable.sortOrder === 'asc' ? 'desc' : 'asc');
                        } else {
                            this.detailsHistoryTable.sortOrder = selectedSortColumn.sortOrder;
                        }
                        this.detailsHistoryTable.sortField = dbSortField;
                        this.detailsHistoryTable.offset = 0;
                        this.$refs.historyDataTable.tableData = _.orderBy(this.projectDetails.history.results, selectedSortField, this.detailsHistoryTable.sortOrder);
                        setTimeout(function () {
                            self.$refs.historyDataTable.table.isLoading = false;
                        }, 1);
                        break;
                    case 'sub-Projects':
                        tableContainer = window.closest($event.target, '.data-section');
                        tableContainer.scrollTop = 0;
                        if (this.detailsSubProjectsTable.sortField === dbSortField) {
                            this.detailsSubProjectsTable.sortOrder = (this.detailsSubProjectsTable.sortOrder === 'asc' ? 'desc' : 'asc');
                        } else {
                            this.detailsSubProjectsTable.sortOrder = selectedSortColumn.sortOrder;
                        }
                        this.detailsSubProjectsTable.sortField = dbSortField;
                        this.detailsSubProjectsTable.offset = 0;
                        this.$refs.subProjectsDataTable.tableData = _.orderBy(this.projectDetails.subProjects.results, selectedSortField, this.detailsSubProjectsTable.sortOrder);
                        setTimeout(function () {
                            self.$refs.subProjectsDataTable.table.isLoading = false;
                        }, 1);
                        break;
                    case 'publications':
                        tableContainer = window.closest($event.target, '.data-section');
                        tableContainer.scrollTop = 0;
                        if (this.detailsPublicationTable.sortField === selectedSortField) {
                            this.detailsPublicationTable.sortOrder = (this.detailsPublicationTable.sortOrder === 'asc' ? 'desc' : 'asc');
                        } else {
                            this.detailsPublicationTable.sortOrder = selectedSortColumn.sortOrder;
                        }
                        this.detailsPublicationTable.sortField = selectedSortField;
                        this.detailsPublicationTable.offset = 0;
                        if (selectedSortField === 'relative_citation_ratio') {
                            defaultRCRVal = this.detailsPublicationTable.sortOrder === 'desc' ? 0 : 1000;
                        }

                        let sortedData = _.orderBy(this.projectDetails.publications.results, [( o ) => { return o[selectedSortField] || defaultRCRVal}], this.detailsPublicationTable.sortOrder);

                        this.setProjectDetails({
                            name: 'publications',
                            data: {
                                meta: this.projectDetails.publications.meta,
                                results: sortedData
                            }
                        });
                        if (this.$refs.pubDataTable) {
                            this.$refs.pubDataTable.tableData = sortedData.slice(0, this.detailsPublicationTable.offset + this.detailsPublicationTable.limit);
                        
                            setTimeout(function () {
                                self.$refs.pubDataTable.table.isLoading = false;
                                self.$refs.pubDataTable.table.loadingMoreData = false;
                            }, 1);
                        }
                        break;
                    case 'patents':
                        tableContainer = window.closest($event.target, '.data-section');
                        tableContainer.scrollTop = 0;
                        if (this.detailsPatentTable.sortField === selectedSortField) {
                            this.detailsPatentTable.sortOrder = (this.detailsPatentTable.sortOrder === 'asc' ? 'desc' : 'asc');
                        } else {
                            this.detailsPatentTable.sortOrder = selectedSortColumn.sortOrder;
                        }
                        this.detailsPatentTable.sortField = selectedSortField;
                        this.detailsPatentTable.offset = 0;
                        this.$refs.patentsDataTable.tableData = _.orderBy(this.projectDetails.patents.results, selectedSortField, this.detailsPatentTable.sortOrder);

                        setTimeout(function () {
                            self.$refs.patentsDataTable.table.isLoading = false;
                        }, 1);
                        break;
                    case 'clinical-studies':
                        tableContainer = window.closest($event.target, '.data-section');
                        tableContainer.scrollTop = 0;
                        if (this.detailsClinicalStudiesTable.sortField === selectedSortField) {
                            this.detailsClinicalStudiesTable.sortOrder = (this.detailsClinicalStudiesTable.sortOrder === 'asc' ? 'desc' : 'asc');
                        } else {
                            this.detailsClinicalStudiesTable.sortOrder = selectedSortColumn.sortOrder;
                        }
                        this.detailsClinicalStudiesTable.sortField = selectedSortField;
                        this.detailsClinicalStudiesTable.offset = 0;
                        this.$refs.clinicalStudiesDataTable.tableData = _.orderBy(this.projectDetails.clinicalStudies.results, selectedSortField, this.detailsClinicalStudiesTable.sortOrder);
                        setTimeout(function () {
                            self.$refs.clinicalStudiesDataTable.table.isLoading = false;
                        }, 1);
                        break;
                    case 'similar-Projects':
                        tableContainer = window.closest($event.target, '.data-section');
                        tableContainer.scrollTop = 0;
                        if (this.detailsSimilarProjectsTable.sortField === dbSortField) {
                            this.detailsSimilarProjectsTable.sortOrder = (this.detailsSimilarProjectsTable.sortOrder === 'asc' ? 'desc' : 'asc');
                        } else {
                            this.detailsSimilarProjectsTable.sortOrder = selectedSortColumn.sortOrder;
                        }
                        this.detailsSimilarProjectsTable.sortField = dbSortField;
                        this.detailsSimilarProjectsTable.offset = 0;
                        this.$refs.similarProjectsDataTable.tableData = _.orderBy(this.projectDetails.similarProjects.results, selectedSortField, this.detailsSimilarProjectsTable.sortOrder);
                        setTimeout(function () {
                            self.$refs.similarProjectsDataTable.table.isLoading = false;
                        }, 1);
                        break;
                }
            }
        },
        exportSectionData (section) {
            switch (section) {
                case 'publications':
                    window.exportDataToCSV('Publications_'+ this.$route.params.appl_id, this.detailsPublicationTable.exportColumns, this.projectDetails.publications.results);
                    break;
                case 'patents':
                     window.exportDataToCSV('Patents_'+ this.$route.params.appl_id, this.detailsPatentTable.exportColumns, this.projectDetails.patents.results);
                    break;
                case 'clinicalStudies':
                    window.exportDataToCSV('Clinical_Studies_'+ this.$route.params.appl_id, this.detailsClinicalStudiesTable.exportColumns, this.projectDetails.clinicalStudies.results);
                    break;
            }
        },
        initExport (name) {
            this.exportSectionName = name;

            this.exportModuleName = '';
            switch (name) {
                case 'subProjects':
                    this.exportModuleName = 'Sub Projects ' + this.getProjectNumber();
                    break;
                case 'projectHistory':
                    this.exportModuleName = 'History ' + this.getProjectNumber();
                    break;
                default:
                    this.exportModuleName = '';
            }
            bus.$emit('export:init');
        },
        exportData (selectedFieldsToExport, callback) {
            var searchParam = {
                "appl_id": this.$route.params.appl_id,
                "export_fields": selectedFieldsToExport,
                "file_format": this.$refs.exportModule.exportFileFormat,
                "project_num": this.projectDetails.basicInfo.project_num
            }
            this.getExportFile(searchParam, callback, this.exportSectionName);
        },
        getHighlightedText (fieldText) {
            var searchTermArr,
                i,
                searchTextRegExp;

            if (this.searchType === 'Smart') {
                searchTermArr = this.$store.state.searchCriteria.smart_search_text
                    .replace(/\+|\(|\)|\\|\?|\*|\.|\[|\]/g, '').split(/\s/);


                for (i = 0; i < searchTermArr.length; i++) {
                    if (searchTermArr[i].trim() !== '') {
                        if (this.stopWords.indexOf(searchTermArr[i]) === -1) {
                            searchTextRegExp = new RegExp(searchTermArr[i], 'ig');
                            if (fieldText.toLowerCase().indexOf(searchTermArr[i].toLowerCase()) !== -1) {
                                fieldText = fieldText.replace(searchTextRegExp, function (str) {
                                    return '<em>' + str + '</em>';
                                });
                            }
                        }
                    }
                }
                return fieldText;
            } else {
                return fieldText.trim();
            }
        },
        shareProject (type) {
            switch (type) {
                case 'email':
					gtag('event','Click', {
						'event_category': 'Email Link',
						'event_label': (this.$route.name === 'list' ? 'Search' : this.$route.name) + '  Project Details',
						'value': (this.$route.name === 'list' ? 'Search' : this.$route.name) + '  Project Details'
					});	
                    break;
                case 'copy':
                    try {
                        let reportLinkInput = document.createElement('input');

                        reportLinkInput.setAttribute('id', 'report-link');
                        reportLinkInput.value = this.shareCopyURL;
                        reportLinkInput.style.opacity = '0';
                        document.body.appendChild(reportLinkInput);

                        reportLinkInput.select();
                        var successful = document.execCommand('copy');

                        reportLinkInput.parentNode.removeChild(reportLinkInput);

                        if (successful) {
                            toast.success(`<strong>Success</strong>\nLink Copied`, {
                                autoClose: 2000, 
                                dangerouslyHTMLString: true,
                                closeButton: true,
                                pauseOnHover: false
                            });
                        }
                    } catch (err) {
                        // $('#copy-msg').html(('Oops, unable to copy'));
                    }
                    //GA
					gtag('event','Click', {
						'event_category': 'Copy Link',
						'event_label': (this.$route.name === 'list' ? 'Search' : this.$route.name) + '  Project Details',
						'value': (this.$route.name === 'list' ? 'Search' : this.$route.name) + '  Project Details'
					});	
            }
        },
        isHrsaOrVaProjects (code) {
            let codes = ["DDA", "CHPS", "DADHP", "DHSS", "DM", "BHP", "DN", "VA"];           
            return code.split(',').some(v => codes.includes(v));
        }
    }
}
</script>


<style lang="scss" scoped>
@import '@/scss/variables.scss';

    // .search-criteria-page {
    //     display: inline-block;
    //     width: calc(100% - 220px);
    //     margin-bottom: 2em;
    //      @media screen and (max-width: 768px) {
    //         display: block;
    //         width: 100%;
    //     }
    // }
    .search-results-section {
        width: 100%;
    }
    .title-container{
        display: inline-block;
        .page-title {
            color: #fff;
            font-size: 28px;
            margin-bottom: 5px;
            margin-right: 15px;
            text-decoration:none;

            &:after {
                background-color: $green;
                transition: 0.3s;
            }

            &.results-title {
                &:after {
                    background-color: rgba(255, 255, 255, 0.25);
                    // transition: 0.3s;
                }

                &:hover,
                &:focus {
                    text-decoration: none;
                    &:after {
                        background-color: $green;
                    }
                    ~ .page-title {
                        &:after {
                            background-color: $green;
                            background-color: rgba(255, 255, 255, 0.25);
                        }
                    }
                }

                ~ .page-title {
                    margin-left: 8px;
                    &:after {
                        background-color: $green;
                    }
                }
            }
        }

        &.matchmaker {
            .page-title {
                &:after {
                    background-color: $orange;
                }

                &.results-title {
                    &:after {
                        background-color: rgba(255, 255, 255, 0.25);
                    }

                    &:hover,
                    &:focus {
                        &:after {
                            background-color: $orange;
                        }
                        ~ .page-title {
                            &:after {
                                background-color: $orange;
                                background-color: rgba(255, 255, 255, 0.25);
                            }
                        }
                    }

                    ~ .page-title {
                        &:after {
                            background-color: $orange;
                        }
                    }
                }
            }
        }
    }

    .disclaimer {
        color: $grey;
        font-size: 13px;
        line-height: 1.25em;
        padding: 10px 0;
        margin: 0 0 10px;
        border-bottom: 3px solid $orange;
    }

    .project-details-page {
        .note {
            font-size: 13px;
            color: $grey;
            width: 70%;
            .sub-note {
                font-style: italic;
                font-size: 11px;
                margin: 5px 0 0;
            }
        }
        .sidebar {
            // box-shadow: 0px 6px 3px 2px rgba(0,0,0,0.2);
            // // min-height: 550px;
            // height: 100%;
            // background-color: $white;
            margin-bottom: 15px;
            .back-btn {
                border-radius: 35px;
                border: none;
                padding: 10px 15px;
                background-color: #fff;
                color: $grey-med;
                margin: 10px auto;
                font-size: 15px;
                display: block;
                font-weight: bold;
                outline: none;
                box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.2);
                transition: 0.3s;
                cursor: pointer;
                &:hover,
                &:focus {
                    box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.35);
                }
                svg {
                    width: 16px;
                    fill: $grey-med;
                }

                @media screen and (max-width: 1300px) {
                    font-size: 13px;
                }
            }
            ul {
                margin: 10px 0 0;
                padding: 0;
                font-size: 16px;
                color: $blue;
                font-weight: 600;
                list-style: none;
                li {
                    a {
                        width: 100%;
                        padding: 10px 15px;
                        display: block;
                        position: relative;
                        .right-icon {
                            display: none;
                        }
                        &.disabled {
                            opacity: 0.5;
                            cursor:not-allowed;
                            &:hover, &:focus {
                                text-decoration: none;
                            }

                        }
                        &.active {
                            background-color: $blue;
                            color: $white;
                            .menu-icon {
                                fill: $white;
                            }
                            .right-icon {
                                display: inline-block;
                                height: 16px;
                                position: absolute;
                                right: 0;
                                top: 10px;
                            }
                        }
                    }
                }
            }
            .menu-icon {
                margin-right: .5em;
                fill: $blue;
            }
            &.fixed-head {
                z-index: 1001;
            }
            .menu-header {
                padding: 10px 10px 5px 20px;
                width: 100%;
                text-align: left;
            }
            .fh-small {
                display: none;
            }
        }
        .inline-data {
            display: none;
        }
        .newline-data {
            display: flex;
            @media (max-width: 767px) {
                display: none;
            }
            a {
                font-weight: normal;
                display: block;
                &.orc_link {
                    display: inline;
                    vertical-align: text-bottom;
                }
            }
        }
        .dataTable {
            position: relative;
        }
        .project-button {
            position: absolute;
            bottom: 0;
            left: 0;
            min-width: 72px;
            z-index: 10;
            border: none;
            background: $blue-nih;
            padding: 4px 20px;
            color: $white;
            border-radius: 35px;
            transition: 0.3s;
            cursor: pointer;
            font-weight: 500;
            &:hover,
            &:focus {
                outline: none;
            }
        }
        .project-details {
            background-color: $grey-lighter;
            padding:0 0 15px;
            font-size: 16px;
            .fixed-data {
                padding: 0 20px;
                max-width: $details-max-width;
                @media screen and (max-width: $screen-md-min) {
                    padding-left: 10px;
                    padding-right: 10px;
                }
            }
            .data-header {
                color: $blue;
                font-size: 18px;
                font-weight: bold;
                padding: 0 0 7px;
                .help-link {
                    float: right;
                    font-size: 16px;
                    vertical-align: text-bottom;
                }
            }
            .project-description.sidebar-sections {
                padding-bottom:25px;
            } 
            .section-header {
                color: $grey;
                font-size: 22px;
                font-weight: bold;
                margin: 0 0 20px;
                position: relative;
                // padding: 0 0 10px;
                width: 100%;
                span {
                    position: relative;
                    &:after {
                        content: "";
                        position: absolute;
                        bottom: -0.3em;
                        left: 0;
                        line-height: 1em;
                        width: 100%;
                        height: 4px;
                        background-color: $yellow;
                    }
                }
                .header-icon {
                    height: 32px;
                    width: 32px;
                    margin-right: 10px;
                    fill: $grey;
                }
                .button-export {
                    background-color: transparent;
                    float: right;
                    color: $grey;
                    font-size: 16px;
                    margin-top: 20px;
                    border: none;
                    outline: none;
                    span {
                        &:after {
                            display:none;
                        }
                    }
                    svg {
                        margin-left: 5px;
                        fill: $grey;
                    }
                }
                &.history {
                    margin-bottom: 0;
                    span {
                        margin-bottom: 20px;
                        display: inline-block;
                    }
                    .button-export {
                        position: absolute;
                        right: 0;
                        bottom: 0;
                    }
                }
            }
            .col-data {
                max-width: 100%;
                margin: 0;
                &.TBD {
                    height: 50px;
                }
            }
            .data-section, .sub-section {
                margin: 0 0 20px;
                padding: 10px 20px;
                background-color: $white;
                // border: 1px solid $grey-light-border;
                color: $grey;
                border-radius: 5px;
                // box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.2);
                box-shadow: 0 2px 8px 0px rgba(0, 0, 0, 0.25);
                position: relative;
                // max-height: 200px;
                .data {
                    // max-height: 100px;
                    // overflow: auto;
                    .term {
                        border-radius: 35px;
                        padding: 3px 15px;
                        background-color: $blue-lightest;
                        color: $grey;
                        font-size: 16px;
                        font-weight: 600;
                        margin: 0 7px 5px 0;
                        display: inline-block;
                    }
                }
                .detailed-info {
                    .data-info {
                        margin: 0 0 7px;
                        font-weight: bold;
                        line-height: 1em;
                        .project-button {
                            margin-top: 5px;
                            position: relative;
                            padding: 8px 20px;
                        }
                    }
                    .sub-col {
                        padding-top: 5px;
                        width: 50%;
                        display: inline-block;
                        &.inline-value {
                            width: 100%;
                            padding-top: 0;
                            .row {
                                margin-top: 12px;
                            }
                            .data-label {
                                padding-left: 0;
                                padding-top: 5px;
                                line-height: 1em;
                            }
                            .data-info {
                                padding: 0;
                                padding-top: 5px;
                                margin: 0;
                            }


                        }
                    }
                }
                &.box {
                    max-width: 100%;
                    // margin: 0;
                    padding: 0;
                    .data-header {
                        padding: 15px 15px 0;
                    }
                    .data-section {
                        border: none;
                        margin: 0;
                        box-shadow: none;
                    }
                }
                &.TBD {
                    height: 150px;
                }
                &.tableOnly {
                    padding: 0 0 0;
                    max-height: 65vh;
                    // min-height: 20vh;
                    overflow: auto;
                    .dataTable {
                        padding: 0;
                    }
                    &.noData {
                        background-color: $white;
                    }
                }
                &.loading-data {
                    min-height: 15vh;
                }
                .loading {
                    .loader {
                        top: 15px;
                        left: 15px;
                    }
                }
            }
            .sub-section {
                border: none;
                border-radius: 0;
                box-shadow: none;
                &.first-section-col {
                    padding-left: 0;
                    padding-right: 0;
                }
            }
            .col-data {
                .data-section {
                    margin-right: 15px;
                    display: inline-block;
                    max-width: calc(33.33% - 10px);
                    vertical-align: text-top;
                    &:last-child {
                        margin-right: 0;
                    }
                    &.col-sm-12 {
                        @media (max-width: 576px) {
                            max-width: 100%;
                        }
                    }
                }
            }
        }
        .project-basics {
            padding: 10px 20px 10px;
            border-bottom: 1px solid $grey-light-border;
            margin-bottom: 15px;
            min-height: 10vh;
            position: relative;
            .loading {
                top: 15px;
                left: 15px;
            }
            .loader {
                top: 15px;
            }
            div {
                width: 100%;
                max-width: $details-max-width;
            }
            .title {
                font-size: 22px;
                font-weight: bold;
                color: $blue-light;
                margin-bottom: 10px;
            }
            .row {
                margin: 0 -15px;
            }
            .data-label {
                display: inline-block;
                font-size: 16px;
                font-weight: 600;
                color: $grey;
            }
            .data {
                color: $blue;
                font-size: 16px;
                font-weight: bold;
            }
            &.fixed-head {
                z-index: 1001;
                background-color: $grey-lighter;
                position: fixed;
                margin: 0 auto;
                // width: 100%;
                width: calc(100% - 250px);
                box-shadow: 8px 2px 8px 0px rgba(0, 0, 0, 0.25);
                border-bottom: none;
                @media screen and (max-width: 1300px) {
                    width: calc(100% - 200px);
                }
                @media screen and (max-width: 1300px) {
                    width: 100%;
                }
                @media screen and (max-width: $screen-md-max)  {
                    width: 100%;
                    position: relative;
                    max-height: 100%;
                    box-shadow: none;
                }
            }
            .nidb_link {
                a {
                    color: $primary;
                    background-color: $white; padding: 2px 10px;
                    border-radius: 15px;
                    font-size: 14px;
                    margin-top: 2px;
                    box-shadow: 0 2px 3px rgba(0, 0, 0, 0.25);
                    &:hover, &:focus {
                        background-color: $primary;
                        color: $white;
                        text-decoration: none;
                    }
                }

            }
        }
        .project-description {
            // padding: 10px 0;
            .project-description-data-wrapper {
                max-height: 20em;
                padding-bottom: 25px;
                overflow: hidden;
                position: relative;
                &.duns-uei-number {
                    max-height: 45px;
                }

                &:not(.no-data) {
                    &:before {
                        content: "";
                        position: absolute;
                        bottom: 18px;
                        left: 0;
                        width: 100%;
                        height: 2rem;
                        background: linear-gradient(to bottom, rgba(255,255,255,0) 0%,rgba(255,255,255,1) 100%);
                        pointer-events: none;
                        transition: 1s;
                        z-index:10;
                    }
                    &:after {
                        content: "";
                        position: absolute;
                        bottom: 0;
                        left: 0;
                        width: 100%;
                        height: 18px;
                        background-color: #fff;
                        pointer-events: none;
                        transition: 1s;
                    }

                    &.expanded {
                        max-height: none;
                        &:before,
                        &:after {
                            opacity: 0;
                        }
                    }
                }

                &.no-data {
                    padding: 0;
                    font-size: 16px;
                    max-height: 30em;
                }

                &.loading {
                    height: 60px;
                    max-height: 100%;
                }

                &.no-read-more {
                    padding: 0;
                    &:before {
                        display:none;
                    }
                    &:after {
                        display:none;
                    }
                }
            }

            .project-description-data {
                min-height: 1vh;
                .data {
                    margin-bottom: 5px;
                }
                &.duns-uei-number {
                    min-height: 20px;
                }
                &.loading {
                    height: 60px;
                    max-height: 100%;
                    padding-bottom: 25px;
                    overflow: hidden;
                    position: relative;
                }
            }

            .news-data-section {
                box-shadow: 0 2px 8px 0px rgba(0, 0, 0, 0.25);
                border-radius: 10px;
                background-color: $white;
                .tableOnly {
                    max-height: 35vh;
                    box-shadow: none;
                    border-radius: 0 0 5px 5px;
                }
                .news-header {
                    background-color: $white;
                    border-radius: 5px 5px 0 0;
                    padding: 0.5em;
                    color: $grey;
                    font-weight: bold;
                }
                .no-data {
                    background-color: $white;
                    border-top: 1px solid $grey-lighter;
                }
            }
        }
    }

    #menu-items {
        @media screen and (min-width: $screen-md-min) {
            display: block;
        }
    }

    @media screen and (max-width: $screen-sm-max) {
        .project-details-page {
            .sidebar {

                .fh-small {
                    display: block;
                    a {
                        background-color: #fff;
                        padding: 5px 12px;
                        display: inline-block;
                        border-radius: 3px;
                        box-shadow: 0 2px 3px rgba(0, 0, 0, 0.25);
                        &:hover,
                        &:focus {
                            text-decoration: none;
                            background-color: $blue-light;
                            color: #fff;
                            .nav-icon-filter {
                                fill: #fff;
                            }
                        }
                    }
                }
                .back-btn {
                    margin: 10px 20px;
                }
            }
            .project-details {
            .data-section, .sub-section {
                // padding: 0 20px;
                padding-left: 10px;
                padding-right: 10px;
                .detailed-info {
                    .sub-col {
                        width: 100%;
                    }
                }
            }
            }
        }

        .col {
                flex-basis: auto;
        }
    }

    .nav-icon {
        $icon-size: 34px;

        display: block;
        margin: 0 auto;

        width: $icon-size;
        height: $icon-size;

        fill: #555;

        transition: 0.3s;
    }

    .nav-icon-filter {
        $icon-size: 24px;

        display: inline-block;
        margin: -2px 4px 0 0;

        width: $icon-size;
        height: $icon-size;

        fill: #5778a1;

        vertical-align: middle;
    }

    .sub-title {
        font-size: 16px;
    }
    .btn.not-collapsed {
        .fas.fa-angle-right {
            transform: rotate(90deg);
        }
    }
    .feature-area {

        .action-buttons {
            position: relative;
            .widget-button {
                // border-radius: 5px;
                margin-left: 10px;
                padding: 5px 22px 5px 22px;
                font-weight: bold;
                box-shadow: $button-shadow;
                &.disabled {
                    cursor: not-allowed;
                }
                .export-loader {
                    position: absolute;
                    left: 13px;
                    top: 7px;
                    width: 5em;
                    height: 5em;
                }
            }
        }
    }
</style>